// AccountRix app constants

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5003/api'

/**
 * The public website. Signing up, and resetting a forgotten password, both
 * live there — someone who cannot sign in cannot be sent to a page inside the
 * app to fix it.
 */
export const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || 'http://localhost:3003'

// localStorage keys
export const TOKEN_KEY = 'accountrix_token'
export const USER_KEY = 'accountrix_user'
export const ACTIVE_COMPANY_KEY = 'accountrix_company_id'

/**
 * Broadcast after a company is added, renamed or removed, so the header's
 * company switcher re-reads the list instead of showing a stale one.
 * Dispatch it with `notifyCompaniesChanged()` below.
 */
export const COMPANIES_CHANGED = 'accountrix:companies-changed'

export const notifyCompaniesChanged = () => window.dispatchEvent(new Event(COMPANIES_CHANGED))

/**
 * Broadcast when the API refuses a request because the company's own password
 * has not been given, or the twelve hours it lasts have run out. The header
 * listens and asks for the password, so an expired unlock is a prompt rather
 * than a screen of red bars with no way to answer them.
 */
export const COMPANY_LOCKED = 'accountrix:company-locked'

export const notifyCompanyLocked = (companyId) =>
  window.dispatchEvent(new CustomEvent(COMPANY_LOCKED, { detail: { companyId } }))

// The product is white-labelled for the client's practice. Change these two
// values (and src/assets/brand/*) to rebrand the whole application — every
// user-visible mention reads from here.
export const APP_NAME = 'Money Flow Accounting'
export const APP_TAGLINE = 'Cloud Accounting'
